/**
 *
 * @constructor
 */
function PagePage() {
    /**
     *
     */
    PagePage.prototype.initialize = function (console, mesh, page) {
        this.id = "page";
        this.console = console;
        this.mesh = mesh;
        this.page = page;

        return this;
    };

    /**
     *
     */
    PagePage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.consoleService.getPage(this.mesh, this.page).done(function (page) {
            this.page = page;

            this.console.consoleService.getChildPages(this.mesh, this.page).done(function (pages) {
                this.page.__childPages = pages;

                this.console.safeApply();
            }.bind(this)).fail();
        }.bind(this)).fail();

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    PagePage.prototype.leave = function () {
    };
}
